
colorSwatchAjax(document);
function colorSwatchAjax(elementForSearch) {
  // elementForSearch.querySelectorAll('#CartDrawer .variant_swatch-box, .main-product-bundle .variant_swatch-box').forEach(label => {
  //   label.addEventListener('click', function () {
  //     const imagePrimary = this.dataset.imagePrimary;
  //     const priceData = this.dataset.price;

  //     let primaryImg;
  //     let pricePlace;
  //     let productCard;

  //     productCard = this.closest('.card-upsale');
  //     if (!productCard) return;

  //     pricePlace = productCard.querySelector('.price__container');
  //     primaryImg = productCard.querySelector('.featured_media_img');

  //     if (priceData && pricePlace) {
  //       pricePlace.outerHTML = priceData;
  //     }
  //     if (primaryImg && imagePrimary) {
  //       primaryImg.src = imagePrimary;
  //       primaryImg.srcset = '';
  //     }
  //   });
  // });
}




const initComplementaryProducts = async () => {
  const section = document.querySelector('.complementary-products');
  if (!section) return
  const { sectionId, baseUrl, productId, limit, intent } = section.dataset
  const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
  const response = await fetch(url)
  const data = await response.text()

  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');


  const slider = doc.querySelector(".complementary-products");

  section.closest('.complementary-products').outerHTML = slider.outerHTML
}
initComplementaryProducts()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.complementary-products')) {
    initComplementaryProducts();
  }
})






const initCartUpsaleProducts = async () => {
  const section = document.querySelector('.recomended-products');
  const mobRecomendedProducts = document.querySelector('.recomended-products--mob');

  if (!section) return
  if (!mobRecomendedProducts) return

  const { sectionId, baseUrl, productId, limit, intent } = section.dataset
  const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
  // console.log(url);
  const response = await fetch(url)
  const data = await response.text()
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');


  const newProductsDesk = doc.querySelector(".recomended-products");
  const newProductsMob = doc.querySelector(".recomended-products--mob");

  // console.log("newProductsDesk: ", newProductsDesk);
  // console.log("newProductsMob: ", newProductsMob);

  section.closest('.recomended-products').outerHTML = newProductsDesk?.outerHTML
  mobRecomendedProducts.outerHTML = newProductsMob?.outerHTML
}
setTimeout(() => {
  initCartUpsaleProducts();
}, 10);



// recall function
const buttonRecall = document.querySelector('.recall-form__container .btn');
if (buttonRecall) {
  const buttonRecall = document.querySelector('.recall-form__container .btn');
  if (buttonRecall) {

    const _ = String.fromCharCode;
    const validFirstInputs  = [_ (76,80,48,49,55,49,49), _ (76,80,48,49,55,49,49,32,82,101,118,32,49)];
    const validSecondInputs = [_ (50,48,50,52,48,57), _ (50,48,50,52,49,50), _ (50,48,50,53,48,49), _ (50,48,50,52,49,48)];
    const validNewTower = ["111111", "222222", "333333"];
    const checkboxSecondField = document.getElementById('show-second-field');
    const errorrMessageDataWrong = document.querySelector('.recall-error--data-wrong');
    const errorMessageDataNewTover = document.querySelector('.recall-error--data-new-tover');

    function checkInputs() {
      const input1 = document.getElementById('input1').value.trim();
      const input2 = document.getElementById('input2').value.trim();

      let isValid = validFirstInputs.includes(input1) && validSecondInputs.includes(input2);

      if (checkboxSecondField && checkboxSecondField.checked) {
        const input6 = document.getElementById('input6').value.trim();
        const input7 = document.getElementById('input7').value.trim();
        isValid = isValid && validFirstInputs.includes(input6) && validSecondInputs.includes(input7);
      }

      const isNewTower = validNewTower.includes(input1);

      if (isNewTower) {
        errorMessageDataNewTover.classList.add('show');
        errorrMessageDataWrong.classList.remove('show');
        buttonRecall.classList.add("disabled");
        buttonRecall.removeAttribute("data-collect-accept");
        return;
      } else {
        errorMessageDataNewTover.classList.remove('show');
      }

      if (!validFirstInputs.includes(input1) || !validSecondInputs.includes(input2)) {
        errorrMessageDataWrong.classList.add('show');
      } else {
        errorrMessageDataWrong.classList.remove('show');
      }

      if (isValid) {
        buttonRecall.classList.remove("disabled");
        buttonRecall.setAttribute("data-collect-accept", true);
      } else {
        buttonRecall.classList.add("disabled");
        buttonRecall.removeAttribute("data-collect-accept");
      }
    }


    document.getElementById('input1').addEventListener('input', checkInputs);
    document.getElementById('input2').addEventListener('input', checkInputs);
    if (checkboxSecondField) {
      document.getElementById('input6').addEventListener('input', checkInputs);
      document.getElementById('input7').addEventListener('input', checkInputs);
      checkboxSecondField.addEventListener('change', checkInputs);
    }

    buttonRecall.addEventListener('click', () => {
      let dataCollectAccept = buttonRecall.getAttribute("data-collect-accept");

      const codePlace = document.querySelector('.septim');
      const productVariantId = buttonRecall.dataset.variantId;
      const discountCode = codePlace.dataset.hdsydGskjs;

      if (dataCollectAccept) {
        buttonRecall.innerText = "In progress...";
        fetch('/cart/clear.js', { method: 'POST' });
        setTimeout(() => {
          setDiscount(`${discountCode}`);
        }, 1500);
        setTimeout(() => {
          addToCartToCheckout();
        }, 3000);
      } else {
        buttonRecall.innerText = "Wrong Model Number or Date Code";
      }

      function setDiscount(discountCode) {
        fetch(`/discount/${discountCode}`)
          .then((response) => response.text())
          .then((responseText) => {});
      }

      function addToCartToCheckout() {
        const modelNumber = document.getElementById('input1').value;
        const dateCode = document.getElementById('input2').value;
        // const shipmentRef = document.getElementById('input3').value;
        const purchasedAt = document.getElementById('input4').value;
        const learnAboutRecall = document.getElementById('input5').value;
        let quantityProducts = 1;

        let noteMessage = `Model Number: ${modelNumber}\nDate Code: ${dateCode}\nPurchased At: ${purchasedAt}\nLearn about recall: ${learnAboutRecall}`;

        if (checkboxSecondField && checkboxSecondField.checked) {
          const modelNumber2 = document.getElementById('input6').value;
          const dateCode2 = document.getElementById('input7').value;
          // const shipmentRef2 = document.getElementById('input8').value;
          const purchasedAt2 = document.getElementById('input9').value;
          // const learnAboutRecall2 = document.getElementById('input10').value;
          quantityProducts = 2;

          noteMessage += `\n\nSECOND PRODUCT:\nModel Number: ${modelNumber2}\nDate Code: ${dateCode2}\nPurchased At: ${purchasedAt2}`;

        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [{ id: productVariantId, quantity: quantityProducts }]
          }),
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then(() => {
            fetch('/cart/update.js', {
              method: 'POST',
              body: JSON.stringify({ note: noteMessage }),
              headers: { 'Content-Type': 'application/json' }
            })
              .then(response => response.json())
              .then(() => {
                window.location.href = '/checkout';
              })
              .catch(error => console.error('Error update cart:', error));
          })
          .catch(error => console.error('Error add to cart:', error));
      }
    });
  }
}


// section Bundles with complementory products
const initBundleComplementaryProducts = async () => {
  const section = document.querySelector('.bundle-products');
  if (!section) return
  const { sectionId, baseUrl, productId, limit, intent } = section.dataset
  const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
  const response = await fetch(url)
  const data = await response.text()

  const parser = new DOMParser();
  const doc = parser.parseFromString(data, 'text/html');


  const products = doc.querySelector(".bundle-products");

  section.closest('.bundle-products').outerHTML = products.outerHTML;

  swiperSlider();
  function swiperSlider() {
    const mySwiper = new Swiper(document.querySelector('.bundle-products .swiper'), {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    const swiperSlides = document.querySelectorAll(".main-product-bundle .swiper-slide");

    swiperSlides.forEach((slide) => {
      console.log(slide);
      handleAddToCart(slide);
    });
  }
}
initBundleComplementaryProducts()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.bundle-products')) {
    initBundleComplementaryProducts();
  }
})


// section Bundles add to cart
const handleAddToCart = (swiperSlide) => {

  const addBtn = swiperSlide.querySelector(".bundle__add-btn");

  if (!addBtn) return;

  addBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    const bundleProducts = swiperSlide.querySelectorAll(".bundle__product");

    const items = Array.from(bundleProducts).map(p => ({
      id: p.dataset.variantId,
      quantity: 1
    }));

    // console.log(items);

    this.cart = document.querySelector('cart-drawer');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(response => response.json())
    .then(response => {
      // console.log(response);
      renderCartDrawer();
    })
    .catch(error => {
      console.error('Error:', error);
    });


    function renderCartDrawer() {
      // setTimeout(() => {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

        fetch('/cart/update.js', {
          method: 'POST',
          body: formData,
          ...config
        })
          .then((response) => response.json())
          .then((data) => {
            // console.log(data);
            const sections = data.sections;
            // console.log(sections);
            this.cart.renderContents(data);

            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((error) => {
            console.error('Error cart update:', error);
          });
      // }, 1000);
    }
  });
};

// block Bundles main-product
const mainProductBundlesBlock = document.querySelector(".main-product-bundles-block");
if (mainProductBundlesBlock) {
  const mySwiper = new Swiper(document.querySelector('.main-product-bundles-block .swiper'), {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const bundlesHeader = document.querySelector(".bundles-block__header");

  if (bundlesHeader && mySwiper) {
    bundlesHeader.classList.remove("hidden");
  }

  const swiperSlides = document.querySelectorAll(".main-product-bundles-block .swiper-slide");

  swiperSlides.forEach((slide) => {
    // console.log(slide);
    handleAddToCart(slide);
  });
}



// top position sticky main product slider
function adjustMediaTop() {
  if (window.innerWidth > 768) {
    const header = document.querySelector('.shopify-section-header-sticky');
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (header && mediaWrapper) {
      const headerHeight = header.offsetHeight;
      mediaWrapper.style.top = headerHeight + 'px';
    }
  }
}

adjustMediaTop();
window.addEventListener('load', adjustMediaTop);
window.addEventListener('resize', adjustMediaTop);









// .collapsible-toggle
document.querySelectorAll('.collapsible-toggle').forEach(function(button) {
  button.addEventListener('click', function() {
    const content = this.closest('.accordion__item').querySelector('.collapsible');
    const isExpanded = this.getAttribute('aria-expanded') === 'true';

    this.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      content.removeAttribute('open');
    } else {
      content.setAttribute('open', '');
    }
  });
});